import React from 'react';
import WebsiteLayout from '../components/layouts/WebsiteLayout';
import { PrivacyPolicy } from '../components/website/PrivacyPolicy';

const PrivacyPolicyPage: React.FC = () => {
  return (
    <WebsiteLayout>
      <div style={{
        maxWidth: '1200px',
        margin: '0 auto',
        padding: '2rem 1rem'
      }}>
        <PrivacyPolicy />
      </div>
    </WebsiteLayout>
  );
};

export default PrivacyPolicyPage;
